import { render } from "./404.vue?vue&type=template&id=33b62a2c&ts=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__